module.exports = __webpack_public_path__ + "img/aParty_121223_J.dbfc1bd2.jpg";